export const resetScriptObj = () => {
  return {
    type: 'RESET_SCRIPT_OBJ',
    payload: {},
  }
}
export const resetScriptStatus = (reset) => {
  return {
    type: 'RESET_SCRIPT_STATUS',
    payload: reset,
  }
}

export const getScriptError = (skillId, error) => {
  return {
    type: 'GET_SCRIPT_ERROR',
    payload: {
      skillId,
      error,
    },
  }
}

export const getScript = (skillId) => {
  return {
    type: 'GET_SCRIPT',
    payload: {
      skillId,
    },
  }
}
export const setScript = (skillId, data) => {
  return {
    type: 'SET_SCRIPT',
    payload: {
      data,
      skillId,
    },
  }
}

export const updateScript = (data) => {
  return {
    type: 'UPDATE_SCRIPT',
    payload: data,
  }
}
export const updatedScript = (data) => {
  return {
    type: 'UPDATED_SCRIPT',
    payload: data,
  }
}

export const setScriptFile = (data) => {
  return {
    type: 'SET_FILE',
    payload: data,
  }
}

export const setScriptExpanded = (id, category, expanded) => {
  return {
    type: 'SET_SCRIPT_EXPANDED',
    payload: { id, category, expanded },
  }
}

export const setScriptDescription = (id, description) => {
  return {
    type: 'SET_SCRIPT_DESCRIPTION',
    payload: { id, description },
  }
}
